<template>
	<div>
		<div style="width: 100%;height: 25vh;background-color: #1F9A2A;color: white;;">
			<div style="padding-top: 10px;font-size: 0.9rem;margin-left: 10px;">
				<div style="display: flex;flex-direction: row;align-items: center;">
					<image src="../assets/image/address.png" style="width: 20px;height: 20px;"></image>
					<span>{{parkName}}</span>
				</div>
				
			</div>
			
			<div style="width: 100%;margin-top: 5vh;font-size: 2rem;margin-left: 15px;">
				<span>无牌车 {{enterForm.plateno}}</span>
			</div>
			
			<div style="width: 100%;margin-top: 5vh;margin-left: 10px;font-size: 1.1rem;">
				<div style="display: flex;flex-direction: row;align-items: center;">
					<img src="../assets/image/fangxiang-you.png" style="width: 25px;height: 25px;margin-right: 5px;">
					<span>请求入场</span>
				</div>
			</div>
		</div>
		<el-button type="primary" style="width: 100%;height:35px;margin-top: 15px;font-size: 15px;" @click='Confirm' :loading="confirmLoading">确定</el-button>

	</div> 
	
</template>

<script>
	import {post} from '../util/util'
	export default {
		data() {
			return {
				confirmLoading:false,

				parkName:'',

				enterForm:null
			}
		},
		created() {
			let form= window.sessionStorage.getItem("ca_pay_authForm")
			if(form){
				this.enterForm = JSON.parse(form)
			}
		},
		mounted(){
			post('pp/createlience',this.enterForm).then(res=>{
				if(res.head.status==="1"){
					this.enterForm.plateno=res.body.carNumber
					this.parkName=res.body.parkName
				}else{
					this.showError=true
					this.errmsg=res.head.message
				}
			})
		},
		methods: {
			Confirm(){
				this.confirmLoading=true
				
				post('pp/enter',this.enterForm).then(res=>{
					this.confirmLoading=false
					console.log(res)
					if(res.head.status==="1" && res.body){
						//有追缴情况，显示追缴费用的具体信息
						res.head.from="enter"
						this.$router.push({name:'queryresult',params:{info:JSON.stringify(res)}})
					}
					else
						this.$router.push({name:'result',params:{info:JSON.stringify(res.head)}})
				})
			}
		}
	}
</script>

<style>

</style>
